import { z } from 'zod';
import { PROVISIONAL_SUBMIT_FIELDS } from './provisional-invoice-schema';

// A single receivable Final-Invoice payment tranche (Launchpad parity): a %
// share of the netted invoice amount collected on a trigger event, or on an
// explicit Fixed Date. The editor keeps these in form state; the payload
// forwards them to the backend, which materialises them as Scheduled payments.
export const PAYMENT_TRANCHE = z.object({
  percentage: z.coerce.number().min(0).max(100),
  trigger: z.string().min(1),
  fixedDate: z.string().optional(),
});

export type PaymentTranche = z.infer<typeof PAYMENT_TRANCHE>;

export const FINAL_SETTLEMENT_SUBMIT_FIELDS = PROVISIONAL_SUBMIT_FIELDS.extend({
  applied_provisional_amount: z.coerce.number().nonnegative(),
  payment_schedule: z.array(PAYMENT_TRANCHE).optional(),
});

export type FinalSettlementSubmitValues = z.infer<typeof FINAL_SETTLEMENT_SUBMIT_FIELDS>;
